import { DEFAULT_TDS_CONFIG } from "./tdsConstants";

const STORAGE_KEY = "brixigo_tds_config_v1";
const WORKSPACE_KEY = "brixigo_tds_workspace_v1";

const DEFAULT_WORKSPACE = {
  regimeSelectedAt: null,
  selectedRegime: null,
  completedSteps: [],
};

export function loadTdsConfig() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return structuredClone(DEFAULT_TDS_CONFIG);
    const parsed = JSON.parse(raw);
    return {
      ...structuredClone(DEFAULT_TDS_CONFIG),
      ...parsed,
      deductor: { ...DEFAULT_TDS_CONFIG.deductor, ...parsed.deductor },
      regime: { ...DEFAULT_TDS_CONFIG.regime, ...parsed.regime },
      calculation: { ...DEFAULT_TDS_CONFIG.calculation, ...parsed.calculation },
      form16: { ...DEFAULT_TDS_CONFIG.form16, ...parsed.form16 },
      windows: { ...DEFAULT_TDS_CONFIG.windows, ...parsed.windows },
    };
  } catch {
    return structuredClone(DEFAULT_TDS_CONFIG);
  }
}

export function saveTdsConfig(config) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
}

export function loadTdsWorkspace() {
  try {
    const raw = localStorage.getItem(WORKSPACE_KEY);
    if (!raw) return structuredClone(DEFAULT_WORKSPACE);
    return { ...structuredClone(DEFAULT_WORKSPACE), ...JSON.parse(raw) };
  } catch {
    return structuredClone(DEFAULT_WORKSPACE);
  }
}

export function saveTdsWorkspace(workspace) {
  localStorage.setItem(WORKSPACE_KEY, JSON.stringify(workspace));
}

export function hasCompletedRegimeSelection() {
  const ws = loadTdsWorkspace();
  return Boolean(ws.selectedRegime && ws.regimeSelectedAt);
}

export function getSelectedOrgRegime() {
  const ws = loadTdsWorkspace();
  if (ws.selectedRegime) return ws.selectedRegime;
  return loadTdsConfig().regime?.defaultRegime || "new";
}

export function saveRegimeSelection(regime) {
  const config = loadTdsConfig();
  config.regime = { ...config.regime, defaultRegime: regime };
  saveTdsConfig(config);
  saveTdsWorkspace({
    ...loadTdsWorkspace(),
    selectedRegime: regime,
    regimeSelectedAt: new Date().toISOString(),
    completedSteps: [],
  });
}

export function markWorkspaceStepComplete(stepId) {
  const ws = loadTdsWorkspace();
  const completed = new Set(ws.completedSteps || []);
  completed.add(stepId);
  saveTdsWorkspace({ ...ws, completedSteps: [...completed] });
}

export function resetRegimeSelection() {
  localStorage.removeItem(WORKSPACE_KEY);
}
